import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, styled } from '@mui/material';
import { Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import ComponentHeaderTitles from '../ComponentHeaderTitles';



const StyledCard = styled(Card)({
  marginBottom: "1rem",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  cursor: "pointer",
  "&.selected": {
    backgroundColor: "#f0f0f0",
  },
});

function SelfStroomOpwekking({ returnsEnergy, setReturnsEnergy, setReturnedEnergyAmount }) {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleCardClick = (event) => {
    setSelectedOption(event);
    setReturnsEnergy(event === "Ja, ik wek zelf stroom op");

    // ensure that the previous values are cleared when the user selects a new option
    if (event === "Nee, ik wek geen stroom op") {
      setReturnedEnergyAmount(null);
    }
  };

  useEffect(() => {
    console.log('returnsEnergy', returnsEnergy);
    // set the first option as default
    if (returnsEnergy === null) {
      handleCardClick("Ja, ik wek zelf stroom op");
    } else {
      handleCardClick(returnsEnergy ? "Ja, ik wek zelf stroom op" : "Nee, ik wek geen stroom op");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
      <div>
        <ComponentHeaderTitles title="Wek je zelf stroom op?" />
        <FormControl component="fieldset">
          <RadioGroup name="stroomOpwekking" value={selectedOption} onChange={(e) => handleCardClick(e.target.value)}>
            <StyledCard
                onClick={() => handleCardClick("Ja, ik wek zelf stroom op")}
                className={selectedOption === "Ja, ik wek zelf stroom op" ? "selected" : ""}
            >
              <CardContent>
                <FormControlLabel
                    value="Ja, ik wek zelf stroom op"
                    control={<Radio />}
                    label={
                      <div className="icon-text-wrapper">
                        {/* Voeg hier je werkelijke icooncomponent of -afbeelding in */}
                        <div className="icon-as-eigenopwek icon-size"></div>
                        <Typography variant="h5" component="h2">
                          Ja, ik wek zelf stroom op
                        </Typography>
                      </div>
                    }
                />
              </CardContent>
            </StyledCard>
            <StyledCard
                onClick={() => handleCardClick("Nee, ik wek geen stroom op")}
                className={selectedOption === "Nee, ik wek geen stroom op" ? "selected" : ""}
            >
              <CardContent>
                <FormControlLabel
                    value="Nee, ik wek geen stroom op"
                    control={<Radio />}
                    label={
                      <div className="icon-text-wrapper">
                        {/* Voeg hier je werkelijke icooncomponent of -afbeelding in */}
                        <div className="icon-as-geeneigenopwek icon-size"></div>
                        <Typography variant="h5" component="h2">
                          Nee, ik wek geen stroom op
                        </Typography>
                      </div>
                    }
                />
              </CardContent>
            </StyledCard>
          </RadioGroup>
        </FormControl>
      </div>
  );
}

SelfStroomOpwekking.displayName = 'SelfStroomOpwekking';
export default SelfStroomOpwekking;
